import React, { useEffect, useMemo, useState } from "react";
import { Loader2 } from "lucide-react";
import { useParams } from "react-router-dom";
import { useMarketing, EmailTemplate } from "../../../context/MarketingContext";
import { fetchEmailTemplateById } from "../../../services/marketingTemplatesApi";
import { EmailTemplateForm } from "./EmailTemplateForm";

const EditEmailTemplatePage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { emailTemplates } = useMarketing();

  const fromList = useMemo(
    () => (id ? emailTemplates.find((t) => t.id === id) : undefined),
    [emailTemplates, id],
  );

  const [resolved, setResolved] = useState<EmailTemplate | null | undefined>(undefined);

  useEffect(() => {
    if (!id) {
      setResolved(null);
      return;
    }
    if (fromList) {
      setResolved(fromList);
      return;
    }
    let cancelled = false;
    setResolved(undefined);
    fetchEmailTemplateById(id)
      .then((row) => {
        if (!cancelled) setResolved(row ?? null);
      })
      .catch(() => {
        if (!cancelled) setResolved(null);
      });
    return () => {
      cancelled = true;
    };
  }, [id, fromList]);

  return (
    <div className="p-4 lg:p-6">
      <div className="mb-4">
        <h2 className="text-base lg:text-lg font-semibold text-gray-900">
          Edit Email Template
        </h2>
        <p className="text-xs lg:text-sm text-gray-500">
          Update the content and description of your email template.
        </p>
      </div>
      {resolved === undefined && (
        <div className="flex flex-col items-center justify-center py-16 gap-3 text-gray-500">
          <Loader2 className="w-10 h-10 text-[#885ABB] animate-spin" />
          <p className="text-sm">Loading template…</p>
        </div>
      )}
      {resolved === null && (
        <p className="text-sm text-red-600">Email template not found.</p>
      )}
      {resolved && <EmailTemplateForm template={resolved} />}
    </div>
  );
};

export default EditEmailTemplatePage;

